import Vue from 'vue'
import { TeamState } from '@/store/types'
import { Scene } from '@/types/scenes'
import { Layout } from '@/types/layouts'
import { UserProfile } from '@/types/users'
import { MemberInvite, Team, TeamGroup } from '@/types/teams'
import { Stream, StreamType, DefaultStream } from '@/types/streams'
import { CastProperty } from '@/types/admin'
import { WarningMessage } from '@/classes/Admin/WarningMessage'
import { KeyDict } from '@/types'
import { firestore } from 'firebase/app'
import { BillingSummary } from '@/types/billing'
import store from '@/store'

const mutations = {
  setActiveTeam (state: TeamState, teamId: string) {
    state.activeTeam = teamId
  },
  setTeam (state: TeamState, team: Team) {
    Vue.set(state, 'team', team)
  },
  loadTeamMembers (state: TeamState, members: UserProfile[]) {
    Vue.set(state, 'currentTeam', members)
  },
  setTeamScenePresets (state: TeamState, presets: { [id: string]: Scene }) {
    state.teamScenes = presets
  },
  setTeamLoaded (state: TeamState, val: boolean) {
    state.teamLoaded = val
  },
  updateTeamMemberCount (state: TeamState) {
    // TODO -> does not have to be here? What is it for?
    state.teamSize = state.teamSize + 1
  },
  setTeamDefaultLayout (state: TeamState, layout: string) {
    state.defaultTeamLayout = layout
  },
  setTeamLayouts (state: TeamState, layouts: Layout[]) {
    state.teamLayouts = layouts
  },
  setTeamGroups (state: TeamState, groups: TeamGroup[]) {
    state.teamGroups = groups
  },
  clearTeamMembers (state: TeamState) {
    state.currentTeam = [] as UserProfile[]
  },
  setAllTeams (state: TeamState, snap: firestore.QuerySnapshot) {
    const teams: Team[] = []
    snap.docs.forEach(doc => {
      const team = doc.data() as Team
      if (!team.version && store.state.admin.release !== null) team.version = store.state.admin.release.default
      teams.push({...team, id: doc.id})
    })
    state.allTeams = teams
  },
  clearAllTeams (state: TeamState) {
    state.allTeams = []
  },
  setInvites (state: TeamState, snap: firestore.QuerySnapshot) {
    const invites: MemberInvite[] = []
    snap.docs.forEach(invite => {
      const data = invite.data() as MemberInvite
      invites.push({...data, id: invite.id })
    })
    Vue.set(state, 'invites', invites)
  },
  setTeamStreams (state: TeamState, snap: firestore.QuerySnapshot) {
    const streams: KeyDict<Stream> = {}
    const validTypes = [StreamType.Broadcast, StreamType.Output]
    snap.docs.forEach(stream => {
      const data = stream.data() as Stream
      if(validTypes.includes(data.type)) streams[stream.id] = {...data, id: stream.id }
    })
    Vue.set(state, 'streams', streams)
  },
  setCastProperties (state: TeamState, snap: firestore.QuerySnapshot) {
    const properties: KeyDict<CastProperty> = {}
    snap.docs.forEach(property => {
      const data = property.data() as CastProperty
      properties[property.id] = {...data, id: property.id }
    })
    Vue.set(state, 'castProperties', properties)
  },
  setDefaultStreams (state: TeamState, streams: DefaultStream[]) {
    Vue.set(state, 'defaultStreams', streams)
  },
  setWarningMessages (state: TeamState, messages: KeyDict<WarningMessage>) {
    state.warningMessages = messages
  },
  clearTeamStreams (state: TeamState) {
    state.streams = {}
  },
  resetTeam (state: TeamState) {
    state.teamLoaded = false
    state.activeTeam = ''
    state.team = {
      id: '',
      deleted: false,
      k360_channel_id: 0,
      members: {},
      name: '',
      facebook: {},
      version: '',
      entity: null,
      customer_id: null
    }
    state.teamSize = 0
    state.version = ''
    Vue.set(state, 'currentTeam', [])
  },
  updateBilling (state: TeamState, snap: firestore.DocumentSnapshot) {
    let summary : BillingSummary = {
      force_resync: undefined,
      last_update: undefined,
      months: {}
    }
    if (snap.exists) {
      summary = snap.data() as BillingSummary
      Vue.set(state.billing, 'summary', summary)
    } else{
      console.log('updateBilling does not exist')
      Vue.set(state.billing, 'summary', summary)
    }
    state.billing.loaded = true

  },
  removeBilling (state: TeamState) {
    Vue.set(state.billing, 'summary', {})
    state.billing.loaded = false
  }
}

export default mutations
